export default {
  ORDERS: 'orders',
  ORDER: 'order',
  ROUTE: 'route'
}
